"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const query_string_1 = __importDefault(require("query-string"));
/**
 * Return param from sources in order:
 * 1. query params
 * 2. localStorage
 *
 * @returns {string, null} string containing param or null
 */
function getParam(param) {
    const values = {
        query: getParamFromQuery(window.location.search, param),
        localStorage: getParamFromLocalStorage(param)
    };
    if (values.query) {
        return values.query;
    }
    else if (values.localStorage) {
        return values.localStorage;
    }
    else {
        return null;
    }
}
exports.getParam = getParam;
/**
 * Return param from query params
 * @returns {string, null} string containing param or null
 */
function getParamFromQuery(queryParamString, param) {
    const parsed = query_string_1.default.parse(queryParamString);
    return parsed[param] || null;
}
exports.getParamFromQuery = getParamFromQuery;
/**
 * Return param from localStorage
 * @returns {string, null} string containing param or null
 */
function getParamFromLocalStorage(param) {
    return window.localStorage.getItem(param);
}
exports.getParamFromLocalStorage = getParamFromLocalStorage;
function getSubdomainFromPath(pathString) {
    if (typeof pathString === 'string') {
        return pathString.split('/')[1] || null;
    }
    return null;
}
exports.getSubdomainFromPath = getSubdomainFromPath;
//# sourceMappingURL=utils.js.map